var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }